// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PharmacyService from '../../../services/Pharmacy.service';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { selectPharmacies, setPharmacies } from '../../../store/reducers/pharmacyReducer';
import type { ReducerAction } from '../../../types/navigationIndex.types';
import type { Pharmacy } from '../../../types/ninox.types';
import { Headline, Loading, View } from '../../atoms';
import { BasicHeader } from '../../organisms/Header/BasicHeader';
import { PremiumPharmacy } from './PharmacyComponent/PremiumPharmacy';
import { StandardPharmacy } from './PharmacyComponent/StandardPharmacy';
import { PharmacyConfirmationModal } from './PharmacyConfirmation';
import classes from './PharmacyList.module.scss';

type PharmacyListProps = {
  setCurrentPage: React.Dispatch<ReducerAction>;
};

export const PharmacyList = ({ setCurrentPage }: PharmacyListProps) => {
  // const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const pharmaciesRedux = useAppSelector(selectPharmacies);

  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const [confirmationModal, setConfirmationModal] = useState(false);

  const [chosenPharmacy, setChosenPharmacy] = useState<Pharmacy>({
    id: 0,
    name: '',
    category: 0,
    isPublic: false,
    descriptionShort: '',
    image: '',
    isVerified: false,
    rating: 0,
    city: '',
    postcode: '',
    street: '',
    houseNumber: '',
    phone: '',
    email: '',
    website: '',
    patientPharmacyrelation: [],
  });

  useEffect(() => {
    if (pharmaciesRedux.length === 0) {
      setLoading(true);

      (async () => {
        const pharmaciesResult = await PharmacyService.getPharmacies('0');
        dispatch(setPharmacies(pharmaciesResult.data));
        setLoading(false);
      })();
    }
  }, []);

  const loadMorePharmacies = async () => {
    setLoading(true);

    const pharmaciesPremium = await PharmacyService.getPharmacies('1');
    const pharmaciesVerified = await PharmacyService.getPharmacies('2');
    const pharmaciesStandard = await PharmacyService.getPharmacies('3');

    const allPharmacies = [
      ...pharmaciesRedux,
      ...pharmaciesPremium.data,
      ...pharmaciesVerified.data,
      ...pharmaciesStandard.data,
    ];
    dispatch(setPharmacies(allPharmacies));

    setShowButton(false);
    setLoading(false);
  };

  const Pharmacies = () => (
    <>
      {pharmaciesRedux.length > 0 &&
        pharmaciesRedux.map((pharmacy) =>
          pharmacy.category === 0 ? (
            <PremiumPharmacy
              key={pharmacy.id}
              pharmacy={pharmacy}
              setConfirmationModal={setConfirmationModal}
              setChosenPharmacy={setChosenPharmacy}
            />
          ) : (
            <StandardPharmacy
              key={pharmacy.id}
              pharmacy={pharmacy}
              setConfirmationModal={setConfirmationModal}
              setChosenPharmacy={setChosenPharmacy}
            />
          )
        )}
    </>
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <BasicHeader />
      <PharmacyConfirmationModal
        pharmacy={chosenPharmacy}
        confirmationModal={confirmationModal}
        setConfirmationModal={setConfirmationModal}
        setCurrentPage={setCurrentPage}
      />

      <View className={classes.PharmacyList}>
        <View className={classes['info-text']}>
          <Headline level={3}>Bitte wählen Sie Ihre Apotheke</Headline>
          <Headline level={4}>In welcher Apotheke möchten Sie Ihr Rezept einlösen?</Headline>
        </View>
        <div className={classes['bigger-width']}>
          <Pharmacies />
        </div>
        {showButton && (
          <div className={classes['more-pharmacies-link']} onClick={() => loadMorePharmacies()}>
            Weitere Apotheken
          </div>
        )}
      </View>
    </React.Fragment>
  );
};
